import React from "react";
import { BulmaBriefPolicyInformationModel } from "SharedConstants/Schema";

export function BriefInformationRows(props: {
  items: [React.ReactNode, React.ReactNode][];
}) {
  return (
    <>
      {props.items.map(([k, v], i) => (
        <div
          key={i}
          className="columns is-gapless"
          style={{ marginBottom: "0.5em" }}
        >
          <div className="column has-text-weight-bold has-text-right-tablet">
            {k}
          </div>
          <div className="column" style={{ marginLeft: "1em" }}>
            {v}
          </div>
        </div>
      ))}
    </>
  );
}

export function BriefPolicyInformation(
  props: BulmaBriefPolicyInformationModel,
) {
  return (
    <BriefInformationRows
      items={[
        ["Policyholder Name", props.PolicyholderName],
        [
          "Coverage Period",
          <>
            <span className="is-inline-block">
              {props.FirstDateOfCoverageString} through
            </span>{" "}
            <span className="is-inline-block">
              {props.FirstDateOfNoCoverageString}
            </span>
          </>,
        ],
        [
          "Insurer",
          <>
            <span className="is-inline-block">{props.Insurer}</span>
            <span className="is-inline-block">{props.InsurerNotes}</span>
          </>,
        ],
      ]}
    />
  );
}
